import { render, staticRenderFns } from "./FaqHome.vue?vue&type=template&id=4a099800&scoped=true&"
import script from "./FaqHome.vue?vue&type=script&lang=js&"
export * from "./FaqHome.vue?vue&type=script&lang=js&"
import style0 from "./FaqHome.vue?vue&type=style&index=0&id=4a099800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a099800",
  null
  
)

export default component.exports